import script from "./searchHeader.vue?vue&type=script&lang=js"
export * from "./searchHeader.vue?vue&type=script&lang=js"

import "./searchHeader.vue?vue&type=style&index=0&id=51c9ee66&lang=scss&scoped=true"

import exportComponent from "/Volumes/kaifa/ApiJavaAdmin/vn-admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51c9ee66"]])

export default __exports__